import React from 'react';
import { Sun, Sunset, Clock } from 'lucide-react';

export const TURNOS = ['Manhã', 'Tarde', 'Integral'];
const ICONE_TURNO = { 'Manhã': Sun, 'Tarde': Sunset, 'Integral': Clock };

export const TurnoToggle = ({ value, onChange, testidPrefix = 'turno', size = 'sm' }) => (
  <div className="flex gap-2 flex-wrap" data-testid={`${testidPrefix}-toggle`}>
    {TURNOS.map((t) => {
      const Icone = ICONE_TURNO[t];
      const ativo = value === t;
      return (
        <button
          key={t}
          type="button"
          onClick={() => onChange(ativo ? '' : t)}
          className={`inline-flex items-center gap-1 rounded-lg border font-medium transition-all ${size === 'sm' ? 'px-3 py-1.5 text-xs' : 'px-4 py-2 text-sm'} ${
            ativo
              ? 'bg-red-600 text-white border-red-600'
              : 'bg-white dark:bg-gray-700 text-gray-600 dark:text-gray-300 border-gray-300 dark:border-gray-600 hover:border-red-400'
          }`}
          data-testid={`${testidPrefix}-${t === 'Manhã' ? 'manha' : t.toLowerCase()}`}
        >
          <Icone className="h-3.5 w-3.5" /> {t}
        </button>
      );
    })}
  </div>
);
